export default __webpack_public_path__ + "static/media/iimg2.346a7616.png";